function onBedrockSignOutUser(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onBedrockSignOutUser', e);
  }

  return window.dispatchEvent(new CustomEvent('onzephrunmountalloutcomes'));
}

export default onBedrockSignOutUser;
